/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationVerification
 */
export interface InvitationVerification {
    /**
     * 
     */
    session_token: string;
    /**
     * 
     */
    referral_id: string;
    /**
     * 
     */
    permissions: Array<string>;
    /**
     * 
     */
    expires_at: Date;
}

/**
 * Check if a given object implements the InvitationVerification interface.
 */
export function instanceOfInvitationVerification(value: object): value is InvitationVerification {
    if (!('session_token' in value) || value['session_token'] === undefined) return false;
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('expires_at' in value) || value['expires_at'] === undefined) return false;
    return true;
}

export function InvitationVerificationFromJSON(json: any): InvitationVerification {
    return InvitationVerificationFromJSONTyped(json, false);
}

export function InvitationVerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationVerification {
    if (json == null) {
        return json;
    }
    return {
        
        'session_token': json['session_token'],
        'referral_id': json['referral_id'],
        'permissions': json['permissions'],
        'expires_at': (json['expires_at'] == null ? json['expires_at'] : parseDateTime(json['expires_at'])),
    };
}

export function InvitationVerificationToJSON(json: any): InvitationVerification {
    return InvitationVerificationToJSONTyped(json, false);
}

export function InvitationVerificationToJSONTyped(value?: InvitationVerification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session_token': value['session_token'],
        'referral_id': value['referral_id'],
        'permissions': value['permissions'],
        'expires_at': value['expires_at'] == null ? value['expires_at'] : serializeDateTime(value['expires_at']),
    };
}

